<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202311_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202311_01_sp.jpg" class="only_sp" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-left"><span>美容皮膚科医の約95％が洗顔はスキンケアにおいて重要と回答！</span><br>正しい洗顔方法や洗顔料の選び方とは？</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <h2 class="mt-5 pt-5">大切なスキンケアアイテム「洗顔料」<br>知ってほしい、その重要性</h2>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202311_02.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">見落としがちな美肌へのステップ「洗顔」</h3>
        <p class="mb-3">みなさんは、美しい肌を保つためにどんなスキンケアにこだわっていますか？</p>
        <p class="mb-3">化粧水、乳液、美容液やパックなどの、与えるケアを大切にしている方が多いかもしれません。</p>
        <p class="mb-3">ご自身の肌に合っているかも大切なポイントですよね。</p>
        <p class="mb-3">では、洗顔料についてはどうでしょうか？</p>
        <p class="mb-3">洗顔は化粧水や乳液、美容液など、その後のお肌に与えるスキンケアの重要な準備ステップ。</p>
        <p>しかし、基礎化粧品の中でもパックや美容液などのスペシャルケアに比べ、洗顔は「洗顔できればばいい」と、それほど重要でないと考える方もいるのではないでしょうか。</p>
      </div>
    </div>
    
    <h2 class="mt-5 pt-5 mb-3">みなさんは"洗顔料"、どれくらい意識してる？</h2>
    <div class="text-center mb-5 pb-5">
      <p class="mb-3">そこで今回は20代～60代の一般女性と美容皮膚科医を対象に、</p>
      <p class="mb-3">「洗顔の実態」に関する調査を実施。</p>
      <p>一般女性の洗顔に対する意識と、美容皮膚科医が考える理想的な洗顔について見ていきましょう。</p>
    </div>

    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3">洗顔料に「こだわっている」と答えた方は約55％<br>こだわりの選び方とは？</h3>
        <p class="mb-3">はじめに、20代～60代の女性に、洗顔料へのこだわりについて調査。</p>
        <p class="mb-3"><strong>「洗顔料にはどの程度こだわっていますか？」</strong></p>
        <p>約半数の方は、洗顔料にこだわりを持っているようです。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202311_03.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202311_04.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3">洗顔料を選ぶときのこだわりと予算は？</h3>
        <p class="mb-3"><strong>「洗顔料はどのような点にこだわって選んでいますか？（複数回答）」</strong></p>
        <p class="mb-3">『泡立ち（62.8%）』<br>『洗い上がりの感触（59.9%）』<br>『保湿力（51.1%）』<br>『洗浄力（46.5%）』<br>『泡の質感（39.4%）』</p>
        <p class="mb-3">みなさん、泡立ちや洗い上がりの感触にこだわる方が多いようです。続いて、普段使用している洗顔料の金額について。</p>
        <p class="mb-3"><strong>「普段使用する洗顔料は、どの程度の金額のものですか？」</strong></p>
        <p>そして約7割の方が、2000円未満の洗顔料を選んでいますね。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3">【よく泡立てて】洗顔をしている人が約60％<br>実は自分の洗顔方法に自信がない？</h3>
        <p class="mb-3">約半数の女性が洗顔料にこだわりがあるようですが、ご自身が行っている洗顔方法について伺いました。</p>
        <p class="mb-3"><strong>「洗顔方法として当てはまるものを教えてください（複数回答可）」</strong></p>
        <p class="mb-3">『よく泡立てて洗う（60.6%）』<br>『こすらず、泡で優しく洗う（38.1%）』</p>
        <p class="mb-3"><strong>「ご自身の洗顔方法は十分正しいものであると思いますか？」</strong></p>
        <p>このアンケートから、多くの方が洗顔にこだわる方が約半数いる一方で、ご自身の洗顔方法に自信がない方が多いと言えそうです。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202311_05.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202311_06.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3">キンケアにおいて洗顔は「重要であると思う」と回答！</h3>
        <p class="mb-3">ここまでの調査で、およそ4割の女性がご自身の洗顔方法は正しくないと感じていることが明らかに。</p>
        <p class="mb-3">では、美容のプロである美容皮膚科医の方に、スキンケアと洗顔について詳しく聞いてみました。</p>
        <p class="mb-3"><strong>「日常的なスキンケアにおいて、洗顔は重要であると思いますか？」</strong></p>
        <p class="mb-3">こちらの質問に対し<strong>、約95％の美容皮膚科医の方が、洗顔はスキンケアにおいて重要</strong>だと回答。</p>
        <p class="mb-3">では、美容皮膚科医から見て、一般女性の洗顔に関する意識はどう見えているのでしょうか。</p>
        <p class="mb-3">なんと、<strong>割の美容皮膚科医が、他のスキンケアと比べて洗顔を重視できていない方が多い</strong>と回答。</p>
        <p>美容皮膚科医の視点からすると、洗顔がおろそかになっていると感じる場面が少なくないのかもしれませんね。</p>
      </div>
    </div>

    <h2 class="mb-3">美容皮膚科医がいう「洗顔を重視するべき理由は」<br>【肌を清潔にする】<br>【肌荒れや乾燥を防ぐ】</h2>
    <h3 class="text-centermb-5 pb-5">では、美容皮膚科医が推奨する洗顔料の選び方とは？</h3>

    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <p class="mb-3">他のスキンケアと比べ洗顔を重視できていない方が多いと実感している美容皮膚科医がおよそ9割いることが明らかに。</p>
        <p class="mb-3">では、<strong>「洗顔を重視すべき理由とは？（複数回答可）」</strong></p>
        <p class="mb-3">半数近くの方が、肌を清潔にすること、乾燥を防ぐことがが大切だと回答しています。</p>
        <p class="mb-3">では、洗顔料を選ぶ際に重視すべきポイントとは何でしょうか？</p>
        <p class="mb-3"><strong>『洗浄効果の高さ（43.7%）』<br>『保湿効果の高さ（41.9%）』<br>『泡立ちの良さ（33.5%）』</strong></p>
        <p class="mb-3">洗浄効果の高さもさることながら、やはり保湿効果の高さも重要視しているということがわかります。</p>
        <p>また、美容皮膚科医だからこそ、洗顔に肌コンディションを整えるような効果も必要だと考えていると言えそうです。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202311_07.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-25">
        <img src="@/assets/img/column/202311_08.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-75 text-center">
        <h3 class="mb-3">洗顔は美肌のために重要なポイント！<br>自分の肌に合ったこだわりの洗顔料で洗おう</h3>
        <p class="mb-3">今回の調査で、20代～60代女性の洗顔に関する意識と美容皮膚科医の考えが明らかになりました。</p>
        <p class="mb-3">洗顔料にある程度こだわっているものの、ご自身の洗顔方法が正しくないと感じる方も多いという結果に。</p>
        <p class="mb-3">また、約95％の美容皮膚科医が、洗顔はスキンケアにおいて重要であると感じていることもわかりました。</p>
        <p>毎日だからこそベーシックなスキンケアは、なるべく肌に負担をかけず、肌に合った洗顔料を選びたいものですね。</p>
      </div>
    </div>
   
    <div class="layer_02 pt-5">
      <img src="@/assets/img/column/202311_09.jpg">
      <div class="layer-text">
        <div class="layer-text-inner">
          <h2 class="mb-3 text-left"><span>自分の素肌に、素直に向き合える</span><br>BASICシリーズ</h2>
          <p class="mb-3">ベーシックケアの製品名すべてに付けられた「薬用」。これは有効成分を一定濃度配合している「医薬部外品」として認められたということを表しています。</p>
          <p class="mb-3">毎日つづける基本のステップにこそ、手応えを感じてほしい。そんな願いから生まれたアイテムです。</p>
          <p>また、一般的にはスペシャルアイテムとされるパックをベーシックケアに取り入れているのも毎日のお手入れの大切さへこだわる、マナビス化粧品ならではです。</p>
        </div>
      </div>
    </div>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="mb-3"><small>知ってほしいのはこの3つ</small></p>
        <p class="mb-3 fs-2">「朝晩の洗顔」「上質泡」「保湿」</p>
        <p class="mb-5">簡単だけど丁寧なルーティンケアの積み重ね。</p>
        <p class="mb-3">朝と夜の「洗顔」タイムで</p>
        <p class="mb-3">素肌をもっちり「上質な泡」で優しく包み込み</p>
        <p class="mb-5">無垢で清潔な状態のお肌をしっかりと「保湿」する。</p>
        <p>女性も男性も年齢に関係なく<br>毎日できる大切なスキンケアは「洗顔」と「保湿」です。</p>
      </div>
    </div>

    <h2 class="mt-5 pt-5 mb-3">ずっと素肌でいたいから。</h2>
    <div class="text-center mb-5 pb-5">
      <p class="mb-3">基本の日々のケアに立ち返り、明日も自分の肌を好きでいるために。</p>
      <p>あなたらしい毎日をあなたのペースで取り入れてみてほしい。</p>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">BASIC<br>薬用スキンウォッシュ<br>チューブタイプ</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">グリチルリチン酸ジカリウム配合。</p>
        <p class="mb-3">毎朝晩の洗顔に。</p>
        <p class="mb-3">うるおいはそのままに、やわらかな泡で包むように洗う。</p>
        <p>16種類の植物由来成分配合のアミノ酸系弱酸性ジェル状せっけん。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_skinwash_tube_202311.jpg">
      </div>
    </div>

    <div class="feature-row feature-row_voice_list">
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p class="mb-3">しっかりとした洗い心地ながら、突っ張ることなく使えます。使った後のスキンケアアイテムの浸透が良い感じ。</p>
        <p>「グリチルリチン酸ジカリウム」が入っているから信頼できる。</p>
      </div>
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p class="mb-3">洗い上がりがさっぱりしてるけど、つっぱらないし潤いが残っている感じ。</p>
        <p>キメの細かい泡で、洗い心地が気持ちいいところもお気に入り。香料なども感じず、自然な印象が良いですね。</p>
      </div>
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p class="mb-3">敏感肌ですが、お肌に優しいこの洗顔ウォッシュを使い出してから、ニキビも落ち着いたし長年愛用してます。</p>
        <p>泡立て機を使うと、より泡がふわふわになるのでおすすめ。</p>
      </div>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_skinmask_tube_202311.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">BASIC<br>薬用スキンマスク<br>チューブタイプ</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">インバスケアで保湿革命。</p>
        <p class="mb-3">洗いたての素肌を包み、<br>うるおし、なめらかにするパック。</p>
        <p>洗い流せる、やわらかなクリーム状のテクスチャーでお風呂でも使えるアイテムです。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>

    <div class="feature-row feature-row_voice_list">
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p class="mb-3">洗い流したあとすべすべもっちもちで美白肌になった感じ。使い始めてお肌がツルツルもちもちになりました！</p>
        <p>顔以外にも使えるので首、デコルテ、手の甲などシワが気になる部分まで使ってます。香りもナチュラルで嬉しい。</p>
      </div>
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p class="mb-3">これ塗って5分湯船浸かって流してみてください。本当によかったです。スキンマスクを使った後のスキンケアの浸透感やばいし、朝起きてもモチモチ肌でした。</p>
        <p>ターンオーバーも促してくれるなんて本当にすごい。</p>
      </div>
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p class="mb-3">厳選した植物由来成分を使用してるだけあって安心して使えます。使用後のお肌がトーンアップして正直驚きました！</p>
        <p>あきらかにお肌のしっとり感が変わり、使い続けて美肌になったと褒められます。</p>
      </div>
    </div>
    
    <h2 class="mt-5 pt-5">その他BASICラインの商品</h2>
    <div class="feature-row feature-row_product_list">
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/basic_lotion_202311.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">薬用エモリエントローション EX</div>
          <p>洗顔後の素肌を、より、みずみずしく。<br>細かな霧が心地よくなじみ、<br>キメを整える、ミストタイプの化粧水。</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/basic_restorejelset_202311.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">薬用レストアジェルセット</div>
          <p>軽いつけ心地なのに、しっとり。<br>水分と油分をバランスよく与える乳液。<br>美白有効成分トラネキサム酸も配合。</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/basic_wrinklegel_202311.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">薬用リンクルジェル</div>
          <p>コクがあるのにベタつかない。<br>なめらかなベールで包みこむように、<br>うるおいを閉じこめるクリーム。</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mb-5 pb-5">
      <p>アンケートの詳細は以下からご覧いただけます。</p>
      <p><a href="https://prtimes.jp/main/html/rd/p/000000003.000124389.html" target="_blank" title="https://prtimes.jp/main/html/rd/p/000000003.000124389.html">紫外線ダメージを受けた肌ケア方法として洗顔はあまり重視されていない？！その理由とは？</a></p>
      <p><a href="https://prtimes.jp/main/html/rd/p/000000004.000124389.html" target="_blank" title="https://prtimes.jp/main/html/rd/p/000000004.000124389.html">美容皮膚科医の約95％が洗顔はスキンケアにおいて重要と回答！正しい洗顔方法や洗顔料の選び方とは？</a></p>
    </div>

    <div class="rte">
      <font size="1">
        <p class="mb-3">一般の方へのアンケート*1<br>
        調査概要：「紫外線を受けた後の肌ケアに関する実態調査」<br>
        【調査期間】2023年9月4日（月）<br>
        【調査方法】リンクアンドパートナーズが提供する調査PR「RRP」によるインターネット調査<br>
        【調査人数】1,011人<br>
        【調査対象】調査回答時に30代～50代女性であると回答したモニター<br>
        【モニター提供元】ゼネラルリサーチ</p>
        <p>美容皮膚科医の方へのアンケート*2<br>
        【調査概要】：「洗顔の実態」に関する調査<br>
        【調査期間】：2023/09/8（金）～2023/09/9（土）<br>
        【調査方法】：リンクアンドパートナーズが提供する調査PR「RRP」によるインターネット調査<br>
        【調査人数】：20代～60代の女性：515人／美容皮膚科医：508人<br>
        【調査対象】：20代～60代の女性／美容皮膚科医<br>
        【モニター提供元】：ゼネラルリサーチ<br>
        ※この調査の内容は、あくまで美容皮膚科医の方を対象にしたアンケート結果の紹介であり、効果や効能を実証するものではありません。</p>
      </font>
    </div>
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
}
.feature-row_product_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}

.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide_text {
  position: absolute;
  left: 10px;
  bottom: 20px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: baseline;
      background-image: url('../../assets/img/column/202311_09.jpg');
      background-size: cover;
      min-height: 750px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
      padding: 60px; /* テキストと画像の端の間に余白を設定 */
    }
    .layer_02 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text {
      padding: 15px;
      max-width: 50%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
   .img-top-slide_text {
      bottom: 55px;
    }
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }

}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>